import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function MainPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState('samara1');
  const [selectedService, setSelectedService] = useState('');
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    lastName: '', firstName: '', middleName: '', gender: '', birthDate: '',
    phone: '', email: '', passportSeries: '', passportNumber: '', passportDivisionCode: '',
    passportIssuedBy: '', passportIssueDate: '', registrationAddress: '', actualAddress: '',
    snils: '', omcPolicy: '', workPlace: ''
  });
  const [errors, setErrors] = useState({});

  const departments = {
    samara1: { id: 'samara1', name: 'Стационарное отделение СОКНД', address: 'Южное шоссе, 18', phone: '+7 (846) 975-29-55', email: 'stationary@sonkd.ru', description: 'Стационарное отделение' },
    samara2: { id: 'samara2', name: 'Детско-подростковое отделение', address: 'Полевая улица, 80и', phone: '+7 (846) 268-08-10', email: 'child@sonkd.ru', description: 'Для детско-подросткового населения' },
    samara3: { id: 'samara3', name: 'Амбулаторное детско-подростковое', address: 'Партизанская улица, 130', phone: '+7 (846) 268-08-10', email: 'child_amb@sonkd.ru', description: 'Амбулаторное детско-подростковое' },
    samara4: { id: 'samara4', name: 'Лаборатория СОКНД', address: 'Улица Победы, 90', phone: '+7 (846) 975-29-55', email: 'lab@sonkd.ru', description: 'Лаборатория' },
    samara5: { id: 'samara5', name: 'Областной наркодиспансер', address: 'Улица Сергея Лазо, 33', phone: '+7 (846) 268-08-10', email: 'info@sonkd.ru', description: 'Областной наркодиспансер' },
    samara6: { id: 'samara6', name: 'Отделение справок для водителей', address: 'Ставропольская улица, 92', phone: '+7 (846) 975-29-55', email: 'driver@sonkd.ru', description: 'Оформление справок' },
    samara7: { id: 'samara7', name: 'Пункт освидетельствования', address: 'Улица Калинина, 32/1', phone: '+7 (846) 268-08-10', email: 'osvidetel@sonkd.ru', description: 'Медосвидетельствование' },
    novokuybishevsk: { id: 'novokuybishevsk', name: 'Новокуйбышевский филиал', address: 'ул. Клары Цеткин, 24', phone: '+7 (846) 975-29-55', email: 'novokuyb@sonkd.ru', description: 'Новокуйбышевский филиал' },
    chapaevsk: { id: 'chapaevsk', name: 'Чапаевский филиал', address: 'ул. Медицинская, 3', phone: '+7 (846) 975-29-55', email: 'chapaevsk@sonkd.ru', description: 'Чапаевский филиал' }
  };

  const categories = [
    { id: 'all', name: 'Все услуги' },
    { id: 'examinations', name: 'Медицинские осмотры и освидетельствования' },
    { id: 'psychotherapy', name: 'Психотерапия, психокоррекция' },
    { id: 'treatment', name: 'Лечение наркологических больных' },
    { id: 'diagnostics', name: 'Лабораторная, функциональная диагностика' },
    { id: 'other', name: 'Прочие услуги' },
    { id: 'education', name: 'Платные образовательные услуги' }
  ];

  useEffect(() => {
    const parsedServices = [
      { id: 1, name: 'Прием врача-психиатра-нарколога первичный', price: 500, category: 'examinations' },
      { id: 2, name: 'Прием врача-психиатра-нарколога повторный', price: 400, category: 'examinations' },
      { id: 4, name: 'Профилактический прием с определением ПАВ в моче', price: 2400, category: 'examinations' },
      { id: 10, name: 'Медосвидетельствование на оружие (врач-нарколог)', price: 3000, category: 'examinations' },
      { id: 27, name: 'Медосвидетельствование на состояние опьянения (полное)', price: 2670, category: 'examinations' },
      { id: 30, name: 'Освидетельствование водителей (нарколог)', price: 950, category: 'examinations' },
      { id: 33, name: 'Освидетельствование водителей категорий A,B,BE,M', price: 2750, category: 'examinations' },
      { id: 35, name: 'Освидетельствование водителей категорий C,D,CE,DE,Tm,Tb', price: 3400, category: 'examinations' },
      { id: 54, name: 'Прием врача-психотерапевта первичный', price: 1000, category: 'psychotherapy' },
      { id: 57, name: 'Индивидуальная психотерапия (Кодирование)', price: 7000, category: 'psychotherapy' },
      { id: 66, name: 'Лечение синдрома отмены алкоголя (1-е сутки)', price: 5600, category: 'treatment' },
      { id: 72, name: 'Общий анализ крови', price: 265, category: 'diagnostics' },
      { id: 73, name: 'Общий анализ мочи', price: 135, category: 'diagnostics' },
      { id: 88, name: 'ЭКГ с расшифровкой', price: 400, category: 'diagnostics' },
      { id: 94, name: 'Проверка по наркологическим учетам', price: 90, category: 'other' }
    ];
    setServices(parsedServices);
    setFilteredServices(parsedServices);
  }, []);

  useEffect(() => {
    let filtered = services;
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(s => s.category === selectedCategory);
    }
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(s => s.name.toLowerCase().includes(term));
    }
    setFilteredServices(filtered);
  }, [selectedCategory, searchTerm, services]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.lastName) newErrors.lastName = 'Фамилия обязательна';
    if (!formData.firstName) newErrors.firstName = 'Имя обязательно';
    if (!formData.gender) newErrors.gender = 'Выберите пол';
    if (!formData.birthDate) newErrors.birthDate = 'Дата рождения обязательна';
    if (!formData.phone) newErrors.phone = 'Телефон обязателен';
    else if (!/^[0-9+\-\s()]{10,15}$/.test(formData.phone)) newErrors.phone = 'Введите корректный номер';
    if (!formData.email) newErrors.email = 'Email обязателен';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = 'Введите корректный email';
    if (!formData.passportSeries) newErrors.passportSeries = 'Серия паспорта обязательна';
    else if (!/^\d{4}$/.test(formData.passportSeries)) newErrors.passportSeries = '4 цифры';
    if (!formData.passportNumber) newErrors.passportNumber = 'Номер паспорта обязателен';
    else if (!/^\d{6}$/.test(formData.passportNumber)) newErrors.passportNumber = '6 цифр';
    if (!formData.passportIssuedBy) newErrors.passportIssuedBy = 'Обязательно';
    if (!formData.passportIssueDate) newErrors.passportIssueDate = 'Обязательно';
    if (!formData.registrationAddress) newErrors.registrationAddress = 'Адрес обязателен';
    if (!formData.snils) newErrors.snils = 'СНИЛС обязателен';
    if (!formData.omcPolicy) newErrors.omcPolicy = 'Полис ОМС обязателен';
    else if (!/^\d{16}$/.test(formData.omcPolicy)) newErrors.omcPolicy = '16 цифр';
    if (!selectedService) newErrors.service = 'Выберите услугу';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    const selectedServiceData = services.find(s => s.id === selectedService);
    
    try {
      const response = await fetch('/api/save_appointment.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formData,
          department: departments[selectedDepartment],
          service: selectedServiceData
        })
      });
      
      const result = await response.json();
      
      if (result.success) {
        alert(`✅ Заявка успешно отправлена!\nНомер карты: ${result.card_number}`);
        setIsModalOpen(false);
        setFormData({
          lastName: '', firstName: '', middleName: '', gender: '', birthDate: '',
          phone: '', email: '', passportSeries: '', passportNumber: '', passportDivisionCode: '',
          passportIssuedBy: '', passportIssueDate: '', registrationAddress: '', actualAddress: '',
          snils: '', omcPolicy: '', workPlace: ''
        });
        setSelectedService('');
        setErrors({});
      } else {
        alert('❌ Ошибка: ' + result.message);
      }
    } catch (error) {
      alert('❌ Ошибка соединения с сервером');
    }
    setIsSubmitting(false);
  };

  const getSelectedServicePrice = () => {
    const service = services.find(s => s.id === selectedService);
    return service ? service.price : 0;
  };

  return (
    <div>
      <header className="header">
        <div className="header-top">
          <div>
            <h1>ГБУЗ «СОКНД» - Самарский областной клинический наркологический диспансер</h1>
            <p>Запись на прием и платные медицинские услуги</p>
          </div>
          <Link to="/adminoff" className="admin-link">🔐 Админ-панель</Link>
        </div>
      </header>

      <main className="main-content">
        <div className="department-selector">
          <label>Выберите отделение:</label>
          <select value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value)} className="department-select">
            <option value="samara1">Стационарное отделение - Южное шоссе, 18</option>
            <option value="samara2">Детско-подростковое - Полевая ул., 80и</option>
            <option value="samara3">Амбулаторное детско-подростковое - Партизанская ул., 130</option>
            <option value="samara4">Лаборатория - ул. Победы, 90</option>
            <option value="samara5">Областной наркодиспансер - ул. Сергея Лазо, 33</option>
            <option value="samara6">Отделение справок - Ставропольская ул., 92</option>
            <option value="samara7">Пункт освидетельствования - ул. Калинина, 32/1</option>
            <option value="novokuybishevsk">Новокуйбышевский филиал - ул. Клары Цеткин, 24</option>
            <option value="chapaevsk">Чапаевский филиал - ул. Медицинская, 3</option>
          </select>
        </div>

        <div className="service-selector">
          <h3>Выберите услугу:</h3>
          <div className="service-filters">
            <input type="text" placeholder="Поиск..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="service-search" />
            <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} className="category-select">
              {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="services-list">
            {filteredServices.map(service => (
              <div key={service.id} className={`service-item ${selectedService === service.id ? 'selected' : ''}`} onClick={() => setSelectedService(service.id)}>
                <div className="service-name">{service.name}</div>
                <div className="service-price">{service.price} ₽</div>
              </div>
            ))}
          </div>
          {selectedService && (
            <div className="selected-service-info">
              <h4>Выбрано:</h4>
              <p>{services.find(s => s.id === selectedService)?.name}</p>
              <p className="selected-service-price">{getSelectedServicePrice()} ₽</p>
            </div>
          )}
        </div>

        <div className="appointment-section">
          <h2>Запись на прием</h2>
          <button className="appointment-button" onClick={() => setIsModalOpen(true)} disabled={!selectedService}>
            {selectedService ? 'Заполнить данные' : 'Сначала выберите услугу'}
          </button>
        </div>
      </main>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>
            <h2>Запись на прием</h2>
            
            <div className="selected-department-info">
              <p>Вы записываетесь в: <strong>{departments[selectedDepartment].name}</strong></p>
              <p>📍 {departments[selectedDepartment].address}</p>
            </div>

            {selectedService && (
              <div className="selected-service-modal">
                <p>Услуга: <strong>{services.find(s => s.id === selectedService)?.name}</strong></p>
                <p className="selected-service-price">Стоимость: {getSelectedServicePrice()} ₽</p>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-section">
                <h3>Личные данные</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Фамилия *</label>
                    <input name="lastName" value={formData.lastName} onChange={handleInputChange} className={errors.lastName ? 'error' : ''} />
                    {errors.lastName && <span className="error-message">{errors.lastName}</span>}
                  </div>
                  <div className="form-group">
                    <label>Имя *</label>
                    <input name="firstName" value={formData.firstName} onChange={handleInputChange} className={errors.firstName ? 'error' : ''} />
                    {errors.firstName && <span className="error-message">{errors.firstName}</span>}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Отчество</label>
                    <input name="middleName" value={formData.middleName} onChange={handleInputChange} />
                  </div>
                  <div className="form-group">
                    <label>Пол *</label>
                    <select name="gender" value={formData.gender} onChange={handleInputChange} className={errors.gender ? 'error' : ''}>
                      <option value="">Выберите</option>
                      <option value="male">Мужской</option>
                      <option value="female">Женский</option>
                    </select>
                    {errors.gender && <span className="error-message">{errors.gender}</span>}
                  </div>
                </div>
                <div className="form-group">
                  <label>Дата рождения *</label>
                  <input type="date" name="birthDate" value={formData.birthDate} onChange={handleInputChange} className={errors.birthDate ? 'error' : ''} />
                  {errors.birthDate && <span className="error-message">{errors.birthDate}</span>}
                </div>
              </div>
              
              <div className="form-section">
                <h3>Контактные данные</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Телефон *</label>
                    <input name="phone" value={formData.phone} onChange={handleInputChange} placeholder="+7 (999) 123-45-67" className={errors.phone ? 'error' : ''} />
                    {errors.phone && <span className="error-message">{errors.phone}</span>}
                  </div>
                  <div className="form-group">
                    <label>Email *</label>
                    <input name="email" value={formData.email} onChange={handleInputChange} className={errors.email ? 'error' : ''} />
                    {errors.email && <span className="error-message">{errors.email}</span>}
                  </div>
                </div>
              </div>
              
              <div className="form-section">
                <h3>Паспортные данные</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>Серия *</label>
                    <input name="passportSeries" maxLength="4" value={formData.passportSeries} onChange={handleInputChange} className={errors.passportSeries ? 'error' : ''} />
                    {errors.passportSeries && <span className="error-message">{errors.passportSeries}</span>}
                  </div>
                  <div className="form-group">
                    <label>Номер *</label>
                    <input name="passportNumber" maxLength="6" value={formData.passportNumber} onChange={handleInputChange} className={errors.passportNumber ? 'error' : ''} />
                    {errors.passportNumber && <span className="error-message">{errors.passportNumber}</span>}
                  </div>
                </div>
                <div className="form-group">
                  <label>Кем выдан *</label>
                  <input name="passportIssuedBy" value={formData.passportIssuedBy} onChange={handleInputChange} className={errors.passportIssuedBy ? 'error' : ''} />
                  {errors.passportIssuedBy && <span className="error-message">{errors.passportIssuedBy}</span>}
                </div>
                <div className="form-group">
                  <label>Дата выдачи *</label>
                  <input type="date" name="passportIssueDate" value={formData.passportIssueDate} onChange={handleInputChange} className={errors.passportIssueDate ? 'error' : ''} />
                  {errors.passportIssueDate && <span className="error-message">{errors.passportIssueDate}</span>}
                </div>
              </div>
              
              <div className="form-section">
                <h3>Адрес</h3>
                <div className="form-group">
                  <label>Адрес прописки *</label>
                  <input name="registrationAddress" value={formData.registrationAddress} onChange={handleInputChange} className={errors.registrationAddress ? 'error' : ''} />
                  {errors.registrationAddress && <span className="error-message">{errors.registrationAddress}</span>}
                </div>
                <div className="form-group">
                  <label>Адрес фактического проживания</label>
                  <input name="actualAddress" value={formData.actualAddress} onChange={handleInputChange} />
                </div>
              </div>
              
              <div className="form-section">
                <h3>Страховые данные</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label>СНИЛС *</label>
                    <input name="snils" value={formData.snils} onChange={handleInputChange} placeholder="000-000-000 00" className={errors.snils ? 'error' : ''} />
                    {errors.snils && <span className="error-message">{errors.snils}</span>}
                  </div>
                  <div className="form-group">
                    <label>Полис ОМС *</label>
                    <input name="omcPolicy" maxLength="16" value={formData.omcPolicy} onChange={handleInputChange} className={errors.omcPolicy ? 'error' : ''} />
                    {errors.omcPolicy && <span className="error-message">{errors.omcPolicy}</span>}
                  </div>
                </div>
              </div>
              
              <div className="form-section">
                <h3>Дополнительная информация</h3>
                <div className="form-group">
                  <label>Место работы/учебы</label>
                  <input name="workPlace" value={formData.workPlace} onChange={handleInputChange} />
                </div>
              </div>
              
              {errors.service && <div className="error-message service-error">{errors.service}</div>}
              
              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? 'Отправка...' : `Записаться (${getSelectedServicePrice()} ₽)`}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default MainPage;